var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorIcon300(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5C5454"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.9063C5 9.98746 8.98746 6 13.9062 6H19.1602V35H13.8615C8.96745 35 5 31.0326 5 26.1385V14.9063Z",
    fill: "#00ADEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.0078,
    height: 5.66406,
    rx: 2.83203,
    transform: "matrix(1 0 0 -1 21.9922 11.6641)",
    fill: "#FFC704"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0938 35H21.9922V14.4961H34V21.4346H29.1563C28.3278 21.4346 27.6563 22.1061 27.6563 22.9346V26.5615C27.6563 27.39 28.3278 28.0615 29.1563 28.0615H33.7819C32.8861 32.0335 29.3364 35 25.0938 35Z",
    fill: "#FF0048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIcon300);
export default __webpack_public_path__ + "static/media/Color - Icon_300.d419caeb5e73ac5f8ef88dc6d287599c.svg";
export { ForwardRef as ReactComponent };